// import 'react-app-polyfill/ie11';
import FIREBASE from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/messaging';
// import 'firebase/compat/analytics';
import firebaseConfig from './firebaseConfig';

export const firebase = FIREBASE;
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseAppAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();

/* -------------------------------------------------
   messaging: ritorna null su Safari / WebKit
   ------------------------------------------------- */
let cachedMessaging:
  | ReturnType<typeof FIREBASE.app>['messaging']
  | null
  | undefined;

export async function getMessaging() {
  if (cachedMessaging !== undefined) return cachedMessaging;

  const supported = await FIREBASE.messaging.isSupported();
  cachedMessaging = supported ? FIREBASE.app().messaging() : null;
  return cachedMessaging;
}

// export const firebaseMessaging = firebaseApp.messaging();
// export const firebaseAnalytics = firebase.analytics();

export const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
  emailProvider: new firebase.auth.EmailAuthProvider(),
};

export function useFirebasePersistence() {
  // Rememeber me is true
  const setLocalPersistence = () =>
    firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

  // Rememeber me is false
  const setSessionPersistence = () =>
    firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

  return {
    persistence: {
      setLocalPersistence,
      setSessionPersistence,
    },
  };
}

// Type alias per firebase auth — usato da _apollo e hooks senza importare firebase direttamente
// Usiamo typeof firebaseAppAuth per evitare ambiguità con firebase.auth.Auth (classe vs tipo)
export type FirebaseAuth = typeof firebaseAppAuth;
// firebase.auth.UserCredential è un'interfaccia (solo tipo, non valore) — funziona direttamente
export type FirebaseUserCredential = Awaited<
  ReturnType<typeof firebaseAppAuth.signInWithEmailAndPassword>
>;
